var map = {
	"./app-icon-2.png": 64662,
	"./app-icon-old.png": 26371,
	"./app-icon.png": 69595,
	"./back.png": 54011,
	"./camera-off.png": 56503,
	"./camera.png": 1251,
	"./confirmer.png": 47421,
	"./connect.png": 83514,
	"./cube.png": 72765,
	"./dice.png": 38527,
	"./exhaust.png": 31318,
	"./exit.png": 32054,
	"./expand.png": 34110,
	"./first-player.png": 3450,
	"./flip-horizontal.png": 91434,
	"./flip-vertical.png": 43316,
	"./focus.png": 90176,
	"./horizontal.png": 414,
	"./image.png": 1831,
	"./left.png": 21857,
	"./loupe.png": 85489,
	"./map.png": 33910,
	"./map2.png": 3190,
	"./mic-mute.png": 78727,
	"./mic.png": 645,
	"./minimize.png": 59222,
	"./next.png": 41057,
	"./options.png": 49274,
	"./question-mark.png": 50866,
	"./refresh.png": 63981,
	"./right.png": 76330,
	"./split-off.png": 9052,
	"./split.png": 18980,
	"./support.png": 45317,
	"./vertical.png": 30080,
	"./x.png": 80796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61740;